// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-detail-page-tsx": () => import("./../../../src/templates/DetailPage.tsx" /* webpackChunkName: "component---src-templates-detail-page-tsx" */),
  "component---src-templates-listing-page-tsx": () => import("./../../../src/templates/ListingPage.tsx" /* webpackChunkName: "component---src-templates-listing-page-tsx" */)
}

